export default "__VITE_ASSET__20d5e87b__"